var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketInstructionOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 120,
    viewBox: "0 0 144 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3248_5001)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 48,
    width: 144,
    height: 72,
    rx: 12,
    fill: "#1E2625"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 48.5,
    width: 143,
    height: 71,
    rx: 11.5,
    stroke: "#E8FAF3",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 56C11.5675 56 8 59.5675 8 64C8 68.4325 11.5675 72 16 72C20.4325 72 24 68.4325 24 64C24 59.5675 20.435 56 16 56Z",
    fill: "white",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 64C8.5 59.8437 11.8437 56.5 16 56.5C20.1588 56.5 23.5 59.8436 23.5 64C23.5 68.1563 20.1563 71.5 16 71.5C11.8437 71.5 8.5 68.1563 8.5 64Z",
    stroke: "#E8FAF3",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 56.5,
    width: 35,
    height: 15,
    rx: 3.5,
    fill: "#1A1D1F",
    stroke: "#23FFB0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 56,
    width: 36,
    height: 16,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.5,
    y: 56.5,
    width: 35,
    height: 15,
    rx: 3.5,
    stroke: "#E8FAF3",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 80,
    width: 128,
    height: 12,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 80.5,
    width: 127,
    height: 11,
    rx: 3.5,
    stroke: "#E8FAF3",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 100,
    width: 128,
    height: 12,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 100.5,
    width: 127,
    height: 11,
    rx: 3.5,
    stroke: "#E8FAF3",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6719 64.2715V32.2715",
    stroke: "#23FFB0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5 60.9355L75.8643 63.8712C76.2857 64.3998 77.0928 64.3998 77.5143 63.8712L79.8357 60.9855",
    stroke: "#23FFB0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91 14C91 21.732 84.732 28 77 28C69.268 28 63 21.732 63 14C63 6.26801 69.268 0 77 0C84.732 0 91 6.26801 91 14ZM77.4197 5.8335L69.6177 8.69656V19.6211L76.7106 22.1668V11.1518L84.3795 8.32617L77.4197 5.8335ZM77.2876 17.4422V11.466L84.3792 8.84388L84.3824 19.9835L77.2876 17.4422Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3248_5001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketInstructionOne);
export default __webpack_public_path__ + "static/media/MarketInstructionOne.d572d6b71963b72fe2a2ccbd92060640.svg";
export { ForwardRef as ReactComponent };